export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_06.bf74ebc6.jpg";